const METRIC_BUFFER_KEY = '__CAN_EAT_DASHBOARD_PERFORMANCE__'
const LOGGING_STORAGE_KEY = 'dashboardPerformanceLogging'
const REPORTING_STORAGE_KEY = 'dashboardPerformanceReporting'
const SLOW_METRIC_THRESHOLD_MS = 1500
const MAX_BUFFERED_METRICS = 200
const MAX_REPORTED_METRICS_PER_SESSION = 50

const isBrowser = () => typeof window !== 'undefined'

let reportedMetricCount = 0

const getStorageItem = (storage, key) => {
  try {
    return storage?.getItem(key)
  } catch (error) {
    return null
  }
}

const shouldLogPerformanceMetric = (duration) => {
  if (!isBrowser()) return false

  return (
    process.env.NODE_ENV !== 'production' ||
    getStorageItem(window.localStorage, LOGGING_STORAGE_KEY) === 'true' ||
    duration >= SLOW_METRIC_THRESHOLD_MS
  )
}

const shouldReportPerformanceMetric = (duration, forceReport) => {
  if (!isBrowser() || process.env.NODE_ENV !== 'production') return false

  return (
    forceReport ||
    duration >= SLOW_METRIC_THRESHOLD_MS ||
    getStorageItem(window.localStorage, REPORTING_STORAGE_KEY) === 'true'
  )
}

const reportMetric = (metric, forceReport) => {
  if (!shouldReportPerformanceMetric(metric.duration || 0, forceReport)) return
  if (reportedMetricCount >= MAX_REPORTED_METRICS_PER_SESSION) return

  reportedMetricCount += 1
  const scheduleReport =
    window.requestIdleCallback ||
    ((callback) => window.setTimeout(callback, 1000))

  scheduleReport(() => {
    import('./reportDashboardPerformanceMetric')
      .then(({ default: reportDashboardPerformanceMetric }) =>
        reportDashboardPerformanceMetric(metric)
      )
      .catch(() => null)
  })
}

const getPerformanceNow = () =>
  isBrowser() && window.performance ? window.performance.now() : Date.now()

const recordDashboardPerformanceMetric = ({
  name,
  detail = {},
  duration,
  report = false
}) => {
  if (!isBrowser()) return

  const metric = {
    name,
    detail,
    duration: Number.isFinite(duration)
      ? Math.round(duration * 100) / 100
      : undefined,
    timestamp: Date.now()
  }
  const metrics = window[METRIC_BUFFER_KEY] || []
  metrics.push(metric)
  window[METRIC_BUFFER_KEY] = metrics.slice(-MAX_BUFFERED_METRICS)

  if (shouldLogPerformanceMetric(metric.duration || 0)) {
    // eslint-disable-next-line no-console
    console.info('[dashboard-performance]', metric)
  }

  reportMetric(metric, report)
}

const measureDashboardAsync = async (name, detail, callback) => {
  const start = getPerformanceNow()

  try {
    return await callback()
  } finally {
    recordDashboardPerformanceMetric({
      name,
      detail,
      duration: getPerformanceNow() - start
    })
  }
}

export {
  getPerformanceNow,
  recordDashboardPerformanceMetric,
  measureDashboardAsync
}
